import { NgModule } from "@angular/core";
import { CoreModule } from "../../core/core.module";
import { ModalModule } from "@modules/app-modal/modal.module";
import { BpModalIntroScreenItemComponent } from "@modules/shared/bp-modal-intro-screen/bp-modal-intro-screen-item/bp-modal-intro-screen-item.component";
import { BpModalIntroScreenComponent } from "@modules/shared/bp-modal-intro-screen/bp-modal-intro-screen.component";

const components = [BpModalIntroScreenItemComponent, BpModalIntroScreenComponent];

@NgModule({
	imports: [CoreModule, ModalModule],
	declarations: [...components],
	exports: [...components]
})
export class BpModalIntroScreenModule {}
